/** Encode File as base64 (data URL stripped) for add-ins API attachments. */
export async function fileToBase64Payload(file: File): Promise<{
  filename: string;
  content_base64: string;
  mime_type?: string;
}> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result as string;
      const comma = dataUrl.indexOf(',');
      const content_base64 = comma >= 0 ? dataUrl.slice(comma + 1) : dataUrl;
      resolve({
        filename: file.name,
        content_base64,
        mime_type: file.type || undefined,
      });
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}

export async function filesToAttachmentPayloads(
  files: File[]
): Promise<Array<{ filename: string; content_base64: string; mime_type?: string }>> {
  return Promise.all(files.map((f) => fileToBase64Payload(f)));
}

const DOC_ACCEPT = /(\.|\/)(docx|pdf|txt|md)$/i;

export function filterDocumentAttachments(fileList: FileList | File[]): File[] {
  const out: File[] = [];
  const arr = Array.from(fileList);
  for (const f of arr) {
    const name = f.name || '';
    if (DOC_ACCEPT.test(name) || f.type.includes('word') || f.type === 'application/pdf' || f.type === 'text/plain') {
      out.push(f);
    }
  }
  return out;
}
